module.exports = __webpack_public_path__ + "img/1.6302dac7.jpg";